import { VcfSizingOutput } from 'pcs-domain';
import { WORKLOAD_DOMAIN_TYPE } from '../../enums/pcsizer';
import { VCPM } from 'pcs-domain';
import { PcsSizingEngineResponse } from 'pcs-domain';
import { VcenterHostCountModal } from "./project-details.state";
import { StagedChange } from '../../core/services/output-staged-changes.service';

export class UpdateSideNav {
  static readonly type = '[Project Details] Update Side Nav';
  constructor(public architecture: string, public deployment: string) {}
}

export class ResetSideNav {
  static readonly type = '[Project Details] Reset Side Nav';
}

export class ActivateNextTab{
  static readonly type = '[Project Details] Activate Next Tab';
  constructor() {}
}

export class ActivateSelectedTab{
  static readonly type = '[Project Details] Activate selected Tab';
  constructor(public tabId: string) {}
}

export class ActivateSelectTabs{
  static readonly type = '[Project Details] Activate select Tabs';
  constructor(public tabs: string[]) {}
}

export class DeActivateSubsequentTabs{
  static readonly type = '[Project Details] De-Activate Subsequent Tab(s)';
  constructor(public tabs: string[]) {}
}

export class SetSelectedRecommendationNode{
  static readonly type = '[Project Details] Set Selected Recommendation Node';
  constructor(public nodeId: string) {}
}

export class SetOutputView{
  static readonly type = '[Project Details] Set Output View';
  /** `nodeId` lets a caller that already knows exactly where it wants to land (e.g. the
   *  Recommendation Summary banner's Details button) switch view and select a node in ONE reducer
   *  pass - two separate dispatches would have this action's own default-node logic overwrite the
   *  intended node. Omit it to keep today's "jump to a sensible default" behavior. */
  constructor(public view: 'cluster' | 'workload', public nodeId?: string) {}
}

export class GetComponents{
  static readonly type = '[Project Details] Get Components for selected domain';
  constructor(public productName: string | undefined, public version: string | undefined, public domain: string | undefined, public architecture: string | undefined)  {}
}

export class GetWorkloadInputConfigiuration{
  static readonly type = '[Project Details] Get Workload Input Configuration for selected domain';
  constructor(public productName: string | undefined, public version: string | undefined, public domain: string | undefined, public architecture: string | undefined, public storageType: string | undefined, public vsanArchitecture: string | undefined, public workloadOption: string | undefined, public deploymentCode: string | undefined, public profileModeCode: string | undefined)  {}
}

/** dHCI (vSAN Max) limits/defaults - clusterType=D_HCI Configuration API; constant for dHCI so the service caches it per product/version. */
export class GetDhciInputConfiguration{
  static readonly type = '[Project Details] Get dHCI Input Configuration';
  constructor(public productName: string | undefined, public version: string | undefined)  {}
}

export class GetHftRaidsInputConfigiuration{
  static readonly type = '[Project Details] Get Hft Raids Input Configuration';
  constructor(public productName: string | undefined, public version: string | undefined, public storageType: string | undefined, public vsanArchitecture: string | undefined, public workloadOption: string | undefined, public deploymentCode: string | undefined, public profileModeCode: string | undefined, public hostfailurestotolerate: number | undefined, public strategies: string | undefined, public clusterType?: 'HCI' | 'D_HCI')  {}
}

export class GetIOProfileInputConfigiuration{
  static readonly type = '[Project Details] Get IO Profile Input Configuration';
  constructor(public productName: string | undefined, public version: string | undefined, public storageType: string | undefined, public vsanArchitecture: string | undefined, public workloadOption: string | undefined, public deploymentCode: string | undefined, public profileModeCode: string | undefined, public ioaccesspattern: string | undefined, public strategies: string | undefined)  {}
}

export class ResetHftRaidsAndIoProfileConfig {
  static readonly type = '[Project Details] Reset Hft Raids And IO Profile Config';
}

export class GetvSANOverheadsInputConfigiuration{
  static readonly type = '[Project Details] Get vSAN Overheads Configuration';
  constructor(public productName: string | undefined, public version: string | undefined, public storageType: string | undefined, public vsanArchitecture: string | undefined, 
    public workloadOption: string | undefined, public deploymentCode: string | undefined, public profileModeCode: string | undefined, 
    public ioaccesspattern: string | undefined, public hostfailurestotolerate: number | undefined, public ioRatio: string | undefined, public ioSize: number | undefined, public raid: string | undefined, 
    public storageEfficiencyMode: string | undefined, public storageEfficiencyValue: number | undefined,
    public nodeCapacityTb: number | undefined, public cpuCoresPerNode: number | undefined, public memoryGb: number | undefined, public networkGbe: number | undefined,
    public maxStorageDevices: number | undefined, public clusterType: string | undefined,
    public strategies: string | undefined,
    public hardwareConfigMode: string | undefined = undefined
  )  {}
}

export class GetWorkloadTypeConfiguration {
  static readonly type = '[Project Details] Get Workload Type Configuration';
  constructor(
    public productName: string | undefined, public version: string | undefined, public storageType: string | undefined, public vsanArchitecture: string | undefined,
    public workloadOption: string | undefined, public deploymentCode: string | undefined, public profileModeCode: string | undefined,
    public ioaccesspattern: string | undefined, public hostfailurestotolerate: number | undefined, public ioRatio: string | undefined, public ioSize: number | undefined, public raid: string | undefined,
    public nodeCapacityTb: number | undefined, public cpuCoresPerNode: number | undefined, public memoryGb: number | undefined, public networkGbe: number | undefined,
    public maxStorageDevices: number | undefined, public clusterType: string | undefined,
    public strategies: string | undefined,
    public liveOpticsProjectId: string | undefined = undefined,
    public hardwareConfigMode: string | undefined = undefined
  )  {}
}

export class ResetState {
  static readonly type = '[Project Details] Reset State';
}


export class FetchProjectById {
    static readonly type = '[Project Details] Fetch Project by Id';
    constructor(public projectId: string) { }
}

export class FetchCustomerList {
    static readonly type = '[Project Details] Fetch Customer List';
    constructor(public searchKey: string) { }
}

export class UpdateProject {
    static readonly type = '[Project Details] Update Project';
    constructor(public projectId: string, public projectPayload: any, public pushToSupercollider?: boolean) {}
}

export class SaveProject {
    static readonly type = '[Project Details] Save Project';
    constructor(public projectMetadata: VCPM.Metadata, public projectData: any) {}
}

export class UpdateProjectMetadata {
    static readonly type = '[Project Details] Update Project Metadata';
    constructor(public project: VCPM.Project) {}
}

export class GetProductDetails {
  static readonly type = '[Project Details] Get Product Details';
}

export class SetVcenterHostCount {
  static readonly type = '[Project Details] Set Vcenter HostCount';
  constructor(public hostCountModalObject: VcenterHostCountModal) {}
}

export class GetProductOfferings {
  static readonly type = '[Project Details] Get Product Offerings';
}

export class UpdateWldSwComponents{
  static readonly type = '[Project Details] Update Software Components of the Workload Domain of the provided index';
  constructor(public swComponentsData: any, public tabId: number | undefined, public inputsChangedInWLD: boolean) {}
}

export class UpdateWldList{
  static readonly type = '[Project Details] Update Workload List of the Workload Domain of the provided index';
  // skipPersist: patch state only and leave the single VCPM PUT to the caller (see handleWorkloadFormUpdate).
  constructor(public workloadList: VCPM.Workload[], public domainId: number | undefined, public skipPersist = false) {}
}

export class UpdateWorkloadReadyNodeRecommendation {
  static readonly type = '[Project Details] Update selected ReadyNode recalculation for a workload recommendation';
  constructor(
    public requirementsId: string,
    public workloadId: string,
    public hardwareConfiguration: VCPM.HardwareConfiguration,
    public result: PcsSizingEngineResponse.WorkloadRecommendation,
    public clusterType: 'CON' | 'SON' | 'HCI',
  ) {}
}

export class UpdateManagementDomainReadyNodeRecommendation {
  static readonly type = '[Project Details] Update selected ReadyNode recalculation for the management domain';
  constructor(
    public hardwareConfiguration: VCPM.HardwareConfiguration,
    public result: PcsSizingEngineResponse.WorkloadRecommendation,
  ) {}
}

/**
 * Cluster View's cluster-scoped counterpart to UpdateWorkloadReadyNodeRecommendation: persists a
 * Recalculate result (ReadyNode for HCI/SON, ESXi for CON) onto the cluster entity's own canonical
 * hardwareConfiguration AND fans it out across every workload referencing that cluster - both their
 * input-side local-mirror hardwareConfiguration and their output-side selectedReadyNodeRecommendation
 * - in one currentProject patch / one UpdateProject dispatch. `resultsByWorkloadId` must contain an
 * entry for every workload sharing the cluster (see extractClusterWorkloadRecommendations - the
 * facade service guarantees this all-or-nothing before this action is ever dispatched).
 */
export class RecalculateClusterHardwareConfiguration {
  static readonly type = '[Project Details] Persist a cluster-level Recalculate result across every referencing workload';
  constructor(
    public requirementsId: string,
    public clusterId: string,
    public clusterKind: 'HCI' | 'COMPUTE' | 'STORAGE',
    public hardwareConfiguration: VCPM.HardwareConfiguration,
    public resultsByWorkloadId: Map<string, PcsSizingEngineResponse.WorkloadRecommendation>,
  ) {}
}

export class CommitOutputSelections {
  static readonly type = '[Project Details] Commit a staged output-page selection (tier profile or ReadyNode) for one workload/domain tab';
  constructor(
    public key: string,
    public change: StagedChange,
  ) {}
}


export class UpdateManagementDomainSwComponents{
  static readonly type = '[Project Details] Update Software Components of the Management Domain';
  constructor(public swComponentsData: any, public inputsChangedInMgmtDomain: boolean) {}
}

export class UpdateManagementDomainConfiguration{
  static readonly type = '[Project Details] Update Configuration of the Management Domain';
  // `save` defaults to true (persist to VCPM immediately). Pass false to patch local
  // NGXS state only, deferring the VCPM save to a subsequent action (e.g. a recommendation
  // save right after) so both changes reach the server in a single PUT.
  constructor(public configuration: VCPM.ManagementDomainConfiguration, public save: boolean = true) {}
}

export class UpdateDomainName{
  static readonly type = '[Project Details] Update name of the Workload Domain of the provided index';
  constructor(public domainName: any, public tabId: number | undefined, public domainType: WORKLOAD_DOMAIN_TYPE) {}
}

export class DeleteWorkloadDomain{
  static readonly type = '[Project Details] Delete Selected Workload Domain';
  constructor(public domainName: any, public tabId: number | undefined) {}
}

export class CloneWorkloadDomain{
  static readonly type = '[Project Details] Clone Selected Workload Domain';
  constructor(public domainName: string | undefined, public tabId: number | undefined, public domainType: string | undefined) {}
}

export class UpdateManagementDomainRecommendation{
  static readonly type = '[Project Details] Update Management Domain recommendation to the project data output';
  constructor(public recommendation: any, public userExit: boolean){}
}

export class UpdateWorkloadDomainRecommendation{
  static readonly type = '[Project Details] Update Workload Domain recommendations to the project data output';
  constructor(public recommendation: any, public userExit: boolean){}
}

export class PPTReportDownload{
  static readonly type = '[Project Details] PPT Report Download';
  constructor(public product: string, public version: string, public project: VCPM.Project){}
}

export class SaveSummary {
  static readonly type = '[Project Details] Save Summary';
  constructor(public summary: VcfSizingOutput.Summary | undefined, public saveToVCPM: boolean = true) {}
}

export class SaveSupercolliderEvent {
  static readonly type = '[Project Details] Save Supercollider Event';
  /** `projectId` is null for features without a project, such as Quick Sizer. */
  constructor(public projectId: string | null, public eventType: string, public userId?: string) {}
}

export class LockProject {
  static readonly type = '[Project Details] Lock Project';
  constructor(public projectId: string, public isAdminUserRequest: boolean = false) {}
}

export class UnlockProject {
  static readonly type = '[Project Details] Unlock Project';
  constructor(public projectId: string, public isAdminUserRequest: boolean = false) {}
}

export class ClearProjectDetailsState {
  static readonly type = '[Project Details] Clear State';
}

// vSAN Max (dHCI): shared "Use Existing Cluster" reusable-entity persistence. Create/Update split
// per entity type — `Create*` assigns `name` internally from its own project-wide counter (never
// accepts one); `Update*` payloads have no `name` field at all, enforcing id/name immutability at
// the type level. See the plan's "Naming convention" and Risk #8.

export class CreateHciCluster {
  static readonly type = '[Project Details] Create a new HCI Cluster in a Workload Domain';
  constructor(
    public domainId: number,
    public workloadId: string,
    public hardwareConfiguration: VCPM.HardwareConfiguration,
    public clusterConfiguration: VCPM.ClusterConfiguration,
    public vsanArchitecture: string,
    public skipPersist = false,
  ) {}
}

export class UpdateHciClusterConfiguration {
  static readonly type = '[Project Details] Update an existing HCI Cluster (id/name immutable)';
  constructor(
    public domainId: number,
    public clusterId: string,
    public hardwareConfiguration: VCPM.HardwareConfiguration,
    public clusterConfiguration: VCPM.ClusterConfiguration,
    public skipPersist = false,
  ) {}
}

export class CreateComputeCluster {
  static readonly type = '[Project Details] Create a new dHCI Compute Cluster in a Workload Domain';
  constructor(
    public domainId: number,
    public workloadId: string,
    public hardwareConfiguration: VCPM.HardwareConfiguration,
    public clusterConfiguration: VCPM.ComputeClusterConfiguration,
    public vsanArchitecture: string,
    public skipPersist = false,
  ) {}
}

export class UpdateComputeClusterConfiguration {
  static readonly type = '[Project Details] Update an existing dHCI Compute Cluster (id/name immutable)';
  constructor(
    public domainId: number,
    public clusterId: string,
    public hardwareConfiguration: VCPM.HardwareConfiguration,
    public clusterConfiguration: VCPM.ComputeClusterConfiguration,
    public skipPersist = false,
  ) {}
}

export class CreateStorageCluster {
  static readonly type = '[Project Details] Create a new dHCI Storage Cluster (project-wide)';
  constructor(
    public domainId: number,
    public workloadId: string,
    public hardwareConfiguration: VCPM.HardwareConfiguration,
    public clusterConfiguration: VCPM.StorageClusterConfiguration,
    public vsanArchitecture: string,
    public skipPersist = false,
  ) {}
}

export class UpdateStorageClusterConfiguration {
  static readonly type = '[Project Details] Update an existing dHCI Storage Cluster (id/name immutable)';
  constructor(
    public clusterId: string,
    public hardwareConfiguration: VCPM.HardwareConfiguration,
    public clusterConfiguration: VCPM.StorageClusterConfiguration,
    public skipPersist = false,
  ) {}
}

export class GarbageCollectOrphanedClusters {
  static readonly type = '[Project Details] Remove reusable cluster entities no workload references anymore';
  constructor(public skipPersist = false) {}
}

/** Apply only server collaboration fields, preserving unsaved sizing inputs. */
export class RefreshProjectCollaboration {
  static readonly type = '[Project Details] Refresh Collaboration';
  constructor(public project: VCPM.Project) {}
}

/** One workload transaction: prepare all cluster commands against the same baseline. */
export type WorkloadClusterCommand = CreateHciCluster | CreateComputeCluster | CreateStorageCluster
  | UpdateHciClusterConfiguration | UpdateComputeClusterConfiguration | UpdateStorageClusterConfiguration;
export class SaveWorkloadConfiguration {
  static readonly type = '[Project Details] Save workload configuration atomically';
  constructor(public workloadList: VCPM.Workload[], public domainId: number, public commands: WorkloadClusterCommand[]) {}
}
